import axios from "axios";
import config from "app_config";
import {SchoolPublicInfo} from "@custom-types/SchoolInfo.ts";

const APIURL = config.APIURLBase + "schoolpublicinfo";

/**
 * SchoolPublicInfoAPI
 */
interface SchoolPublicInfoGetRequest {
  siteName: string;
}

class SchoolPublicInfoAPI {
  /**
   * get
   * @param {object} data 送信データ 下記dict型データ
   *        {
   *          siteName: 施設名
   *        }
   * @param siteName 施設名
   * @param signal AbortSignal
   * @return 成功時は応答Jsonデータが返る。失敗時はaxios Errorオブジェクトが返る。
   */
  static async get(data: SchoolPublicInfoGetRequest, signal?: AbortSignal): Promise<SchoolPublicInfo> {
    // Load School Public Info
    const res = await axios.get(APIURL + "/" + data.siteName,
      {
        signal: signal,
      }
    );
    return res.data;
  }
}


export {
  SchoolPublicInfoAPI as default,
};
